// extracted by mini-css-extract-plugin
module.exports = {"optsContainer":"styles_optsContainer__2p3t4","optsItem":"styles_optsItem__1yOOW","mobileSelectDropdown":"styles_mobileSelectDropdown__S6vtQ"};